import { apolloClient } from '@/apollo/client'

import { FINMA_REPORTS_GENERATE_QUERY } from '@/graphql/reporting/finmaReport/finmaReportsGenerate'

export const ReportingService = {
    finmaReportsGenerate (variables) {
        return apolloClient.query({
            query: FINMA_REPORTS_GENERATE_QUERY,
            variables,
        }).then(response => response.data.finmaReportsGenerate)
    },
}
